const m06Section = {
  id: 'm06',
  name: '2027ScoresheetM06Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM06Sub2Label',
      id: 'm06_scoring_1',
      options: [
        {
            description: 'noLabel',
            value: false
        },
        {
            description: 'yesLabel',
            value: true
        }
      ]
    },
    {
      scoring: '2027ScoresheetM06Sub3Label',
      id: 'm06_scoring_2',
      options: [
        {
            description: '0',
            value: 0
        },
        {
            description: '1',
            value: 1
        },
        {
            description: '2',
            value: 2
        },
        {
          description: '3',
          value: 3
        },
        {
          description: '4',
          value: 4
        }
      ]
    },
  ]
}

export default m06Section;